
import { addCss, createDriver, resetDriversByNS, waitGetAny } from '@zk/framework-vue';

const CLOSE_ICON_CLASS = 'zk-recorder-function-guider-close-icon';
const addCustomCss = (name: string, className: string) => `
  body * {
    transform-box: view-box;
  }

  .${name} #master-container{
    transform: scale(1);
  }
  #driver-highlighted-element-stage{
    background-color: transparent !important;
  }
  .${name}#driver-popover-item .driver-popover-tip.left {
    border-color: transparent rgb(111, 109, 237) transparent transparent;
  }
  .${name}#driver-popover-item .driver-popover-tip.top {
    border-color: transparent transparent rgb(111, 109, 237) transparent;
  }
  .${name}#driver-popover-item .driver-popover-tip.bottom {
    border-color: rgb(111, 109, 237) transparent  transparent;
  }
  .${name}#driver-popover-item .driver-popover-tip.right {
    border-color: transparent transparent  transparent rgb(111, 109, 237);
  }
  .guide-popover-left{
    transform: translateX(-8px);
  }
  .guide-popover-right{
    transform: translateX(8px);
  }
  .guide-popover-top{
    transform: translateY(-8px);
  }
  .guide-popover-bottom{
    transform: translateY(8px);
  }
 .${name} .driver-highlighted-element {
    border: 2px solid var(--primary-color);
    animation: 3s infinite linear scaleBoxShadow;
    transform: translateX(-2px);
    border-radius: 6px;
  }
  .${name} .zk-float-add-btn.driver-highlighted-element{
    border-radius: 50% !important;
  }
  .zk-confirm-dropdown.driver-highlighted-element{
    // padding: 5px 0 !important;
    // margin-top: -8px !important;
    // margin-bottom: 3px !important;
    background: #fff;
    border-radius: 6px;
    margin-top: -2px !important;;
    margin-bottom: 8px !important;;
  }
  .zk-top-nav__navs ${className}.driver-highlighted-element {
    background: #fff;
  }
  .${name} .zk-air-table .zk-common-filter-top-index__add-filter .iconicon_tianjia.driver-highlighted-element{
    background: #fff;
    border-radius: 6px;
  }
  ${className}.top-nav-automation.driver-highlighted-element{
    transform: translateX(0px);
    background: #fff;
  }
  div.project-list-drawer-create.driver-highlighted-element{
    background: #fff;
    border-radius: 6px !important;
  }
  div.zk-float-add-btn__wrapper.driver-highlighted-element{
    background: #fff;
    transform: translateX(2px) translateY(2px);
  }
  div.zk-left-aside__invite.driver-highlighted-element{
    border-radius: 6px!important;
    transform: none;
  }
  div#driver-popover-item.${name} {
    padding: var(--m-large);
    min-width: 288px;
    max-width: 420px;
    border-radius: 6px;
    background: rgba(111, 109, 237, 1);
    padding: 12px 16px 16px 24px;
    box-shadow: 0px 6px 12px 0px rgba(96, 97, 132, 0.16);
    color: #fff;
  }
  div#driver-popover-item.${name}::before {
    content: '';
    border-radius: 6px;
    width: 60px;
    height: 60px;
    position: absolute;
    left: 0;
    top: 0;
    background: inherit;
    z-index: -1;
  }
  div#driver-popover-item.${name} .driver-popover-footer {
    padding: 0;
    margin-top:24px;
  }
  div#driver-popover-item.${name} .driver-popover-footer .driver-close-btn{
    display: none;
  }
  div#driver-popover-item.${name} .driver-popover-footer .driver-close-only-btn{
    display: inline-block;
  }
  div#driver-popover-item.${name} .driver-popover-footer button {
    border-radius: var(--radius-mini);
    border: 0px solid #fff;
    background: var(--primary-color);
    color: #FFF ;
    padding: 4px 16px;
    font-size: 12px !important;
    height: 32px;
    text-shadow: initial !important;
    box-shadow: 0px 2px 10px 2px rgba(99, 96, 230, 0.16);
    border-radius: 16px;
  }
  div#driver-popover-item.${name} .driver-popover-footer button:hover {
    color: var(--font-color-5) !important;
    background-color: var(--brand-color-6);
    border-color: var(--brand-color-6);
  }
  div#driver-popover-item.${name}  .driver-popover-title {
    line-height: 24px;
    font-size: 13px;
    color: rgba(210, 203, 250, 1) !important;
    padding-right: 20px;
  }

  div#driver-popover-item.${name}  .driver-popover-title .${CLOSE_ICON_CLASS} {
    position: absolute;
    top: -2px;
    right: -8px;
    color: #fff;
    font-size: 24px;
    cursor: pointer;
  }

  div#driver-popover-item.${name}  .driver-popover-title .${CLOSE_ICON_CLASS}:hover {
    opacity: 0.8;
  }

  div#driver-popover-item.${name} .driver-popover-footer-progress {
    margin-top: 12px;
    text-align: right;
    font-size: 12px;
  }

  div#driver-popover-item.${name} .driver-popover-description {
    font-weight: bold !important;
    color: #fff;
    font-size: 14px;
  }
  .guide-popover-automation .driver-popover-tip{
    right: 10px !important;
  }
  .guide-popover-inviteMember .driver-popover-tip{
    left: 15px !important;
  }
  @keyframes scaleBoxShadow{
    0%{
      box-shadow: 0 0 0 6px rgba(99, 96, 230, 0.2);
    }
    25%{
      box-shadow: 0 0 0 2px rgba(99, 96, 230, 1);
    }
    50%{
      box-shadow: 0 0 0 6px rgba(99, 96, 230, 0.2);
    }
    75%{
      box-shadow: 0 0 0 2px rgba(99, 96, 230, 1);
    }
    100%{
      box-shadow: 0 0 0 6px rgba(99, 96, 230, 0.2);
    }
  }`;

export type Config = {
  selector: string;
  getElement?: () => Promise<HTMLElement | null>;
  scopeName: string;
  addScopeCss?: (name: string, className: string) => string;
  popover: any;
  beforeCreateDriver?: () => Promise<void>;
  beforeDestroyDriver?: () => Promise<void>;
  clickToNext?: boolean;
  hoverToNext?: boolean;
  clickToStop?: boolean;
  clickToClose?: boolean;
  hideCloseIcon?: boolean;
  progress?: string;
}

let driver: any = null;

export async function startCustomDriver(options: { config: Config, onClose?: () => void, onNext?: (config: Config) => void, onFooterBtnClick?: (e: MouseEvent) => void}, instance: any) {

  const { config, onClose, onNext, onFooterBtnClick } = options;

  if (driver) {
    stop();
  }

  if (!config) {
    return;
  }

  const { selector, getElement, scopeName, addScopeCss, popover, beforeCreateDriver, beforeDestroyDriver, clickToNext, hoverToNext, clickToStop, clickToClose, progress } = config;

  if (typeof beforeCreateDriver === 'function'){
    const flag: any = await beforeCreateDriver();
    if (flag === false) {
      return;
    }
  }
  let el: HTMLElement | null = null;

  if (typeof getElement === 'function') {
    el = await getElement();
  } else {
    el = await waitGetAny(() => {
      return document.querySelector(selector);
    }, { interval: 50, timeout: 8000 });
  }

  if (!el) {
    console.log('no guide element');
    return;
  }

  const insertCss = addCss(scopeName, (name: string) => {
    let css = addCustomCss(name, selector);
    if (addScopeCss) {
      css += addScopeCss(name, selector);
    }
    return css;
  }, { auto: false });

  async function stop() {
    document.body.classList.remove(insertCss);
    if (typeof beforeDestroyDriver === 'function'){
      await beforeDestroyDriver();
    }
    document.removeEventListener('click', onDocumentClick);
    el?.removeEventListener('click', onHighlightClick);
    el?.removeEventListener('mouseenter', onHighlightMouseenter);
    resetDriversByNS(scopeName, true);
    driver = null;
  }

  async function onDocumentClick(e: MouseEvent) {
    if (!e?.target){
      return;
    }
    const closeIcon = document.querySelector(`.${CLOSE_ICON_CLASS}`);
    if (closeIcon?.contains(e.target as HTMLElement)){
      await stop();
      onClose?.();
    }
    const footerBtn = document.querySelector('.driver-popper-footer__btn');
    if (footerBtn?.contains(e.target as HTMLElement)){
      onFooterBtnClick?.(e);
    }
  }

  async function onHighlightClick() {
    if (clickToNext || clickToStop || clickToClose) {
      await stop();
    }
    if (clickToClose) {
      onClose?.();
    }
    if (clickToNext) {
      onNext?.(config);
    }
  }

  function transformI18nText(text: string) {
    const vueInstance = instance;
    return text.replace(/t\((.*?)\)/g, function(match: string, p1: string) {
      return vueInstance.$t(p1) as string;
    });
  }

  async function onHighlightMouseenter() {
    console.log('onHighlightMouseenter');
    if (hoverToNext) {
      await stop();
      onNext?.(config);
    }
  }

  driver = createDriver(scopeName, {
    className: insertCss,
    allowClose: false,
    opacity: 0.2,
    keyboardControl: false,
    showButtons: false,
    onHighlightStarted: async () => {
      document.body.classList.add(insertCss);
      document.addEventListener('click', onDocumentClick);
      el.addEventListener('click', onHighlightClick);
      el.addEventListener('mouseenter', onHighlightMouseenter);
    },
    async onHighlighted(element: any) {
      const popoverNode = await waitGetAny(() => element.getPopover().getDescriptionNode(), { interval: 50, timeout: 3000 });
      popoverNode.addEventListener('click', (e: MouseEvent) => {
        console.log(e);
      }, { capture: true });
    }
  });

  let description = transformI18nText(popover.description);
  if (progress) {
    description += `<div class="driver-popover-footer-progress">${progress}</div>`;
  }

  driver.highlight({
    element: el,
    popover: {
      ...popover,
      title: config?.hideCloseIcon ? transformI18nText(popover.title) : `${transformI18nText(popover.title)}<em class="zkicon iconqingkongtubiao ${CLOSE_ICON_CLASS}"></em>`,
      description
    }
  });

  return {
    driver,
    stop
  };

}
